import { render, staticRenderFns } from "./swhk.vue?vue&type=template&id=384acba0&scoped=true&"
import script from "./swhk.vue?vue&type=script&lang=js&"
export * from "./swhk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384acba0",
  null
  
)

export default component.exports